import { render, staticRenderFns } from "./DashboardButton.vue?vue&type=template&id=92197724&"
import script from "./DashboardButton.vue?vue&type=script&lang=js&"
export * from "./DashboardButton.vue?vue&type=script&lang=js&"
import style0 from "./DashboardButton.vue?vue&type=style&index=0&id=92197724&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports